<h1 mat-dialog-title style="margin-bottom: 0px">Besprekings</h1>
<p>{{ attenders.length }} bespreking(s)</p>
<div mat-dialog-content>
  <table style="width: 100%">
    <colgroup>
      <col span="1" style="width: 30%" />
      <col span="1" style="width: 30%" />
      <col span="1" style="width: 30%" />
      <col span="1" style="width: 10%" />
    </colgroup>
    <thead>
      <tr style="text-align: left">
        <th>Naam</th>
        <th>Van</th>
        <th>Plek</th>
        <th>Gesondheidsverklaring</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let attender of attenders">
        <td>{{ attender.name }}</td>
        <td>{{ attender.surname }}</td>
        <td>{{ attender.venueDescription }}</td>
        <td>
          <span *ngIf="attender.healthScreening"
            ><mat-icon>check</mat-icon></span
          >
          <span *ngIf="!attender.healthScreening"
            ><mat-icon (click)="data.screen(attender)">edit</mat-icon></span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div mat-dialog-content *ngIf="enterPassword">
  <hr />
  <mat-form-field style="width: 100%" appearance="fill">
    <mat-label>Wagwoord</mat-label>
    <input type="password" matInput [(ngModel)]="password" />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    *ngIf="!enterPassword"
    (click)="enterPassword = !enterPassword"
  >
    Laai af
  </button>
  <button mat-raised-button *ngIf="enterPassword" (click)="downloadFile()">
    Laai af
  </button>
</div>
